<template>
    <div class="backoffice requests">
        <b-container fluid>
            <b-row>
                <b-col cols="10" offset="1">
                    <div class="requests--topbar">
                        <div class="requests--filters">
                            <div class="requests--filter">
                                <b-form-input 
                                    placeholder="R-ID"
                                    type="text" 
                                    size="sm"
                                    v-model="current_rid"
                                ></b-form-input>
                                <div class="requests--remove" v-if="current_rid !== ''"
                                    @click="() => {
                                        page = 1
                                        current_rid = ''
                                        delete filter.rid
                                        get_requests_paginated_from_api()
                                    }"
                                ></div>

                                <b-button class="service-btn" variant="success" size="sm" 
                                            @click="() => {
                                                page = 1
                                                filter.rid = current_rid
                                                get_requests_paginated_from_api()
                                            }" title="ricerca">
                                    <font-awesome-icon icon="search" />
                                </b-button>

                            </div>
                            <div class="requests--filter">
                              <b-dropdown
                                  :text="current_attention_required !== '' ? current_attention_required : 'stato lavorazione'"
                                  :variant="(current_attention_required === '')? 'secondary' : 'success'"
                                  size="sm"
                                  ref="filter_attention_required"
                              >
                                <b-dropdown-item v-for="(opt, index) in attention_required_opts" v-bind:key="'key_current_attention_id_' + index">
                                  <div v-html="opt.label"
                                       @click="() =>
                                                  {
                                                      page = 1
                                                      current_attention_required = opt.label
                                                      filter.attention_required = opt.value
                                                      get_requests_paginated_from_api()
                                                  }
                                              "
                                  ></div>
                                </b-dropdown-item>
                              </b-dropdown>
                              <div class="requests--remove" v-if="current_attention_required !== ''"
                                   @click="() => {
                                          page = 1
                                          current_attention_required = ''
                                          delete filter.attention_required
                                          get_requests_paginated_from_api()
                                      }"
                              ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_status !== '' ? current_status : 'stato richiesta'"
                                    :variant="(current_status == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_status"
                                >
                                    <b-dropdown-item v-for="(status,index) in statuses" v-bind:key="'key_current_status_'+index">
                                        <div v-html="status"
                                            @click="() => 
                                                {
                                                    page = 1
                                                    current_status = status
                                                    filter.request_status = status
                                                    get_requests_paginated_from_api()
                                                }
                                            "
                                        ></div>
                                    </b-dropdown-item>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_status !== ''"
                                    @click="() => {
                                        page = 1
                                        current_status = ''
                                        delete filter.request_status
                                        get_requests_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_quote_title !== '' ? current_quote_title : 'titolo proposta'"
                                    :variant="(current_quote_title == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_quote_title"
                                >
                                    <b-dropdown-form>
                                        <b-form-input type="text" v-model="current_quote_title" size="sm">
                                        </b-form-input>
                                        <b-button size="sm" variant="success"
                                            @click="() => {
                                                page = 1
                                                filter.quote_title = current_quote_title
                                                get_requests_paginated_from_api()
                                            }">
                                            invia
                                        </b-button>
                                    </b-dropdown-form>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_quote_title !== ''"
                                    @click="() => {
                                        page = 1
                                        current_quote_title = ''
                                        delete filter.quote_title
                                        get_requests_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_banconista_id !== '' ? banconiste.filter(function(b){ return b.banconiste_id == current_banconista_id })[0].display_name : 'agente'"
                                    :variant="(current_banconista_id === '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_banconista_id"
                                >
                                    <b-dropdown-item v-for="(banconista, index) in banconiste" v-bind:key="'key_current_banconista_id_' + index">
                                        <div v-html="banconista.display_name"
                                            @click="() => 
                                                {
                                                    page = 1
                                                    current_banconista_id = banconista.banconiste_id
                                                    filter.banconiste_id = banconista.banconiste_id
                                                    get_requests_paginated_from_api()
                                                }
                                            "
                                        ></div>
                                    </b-dropdown-item>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_banconista_id !== ''"
                                    @click="() => {
                                        page = 1
                                        current_banconista_id = ''
                                        delete filter.banconiste_id
                                        get_requests_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_product_code !== '' ? current_product_code : 'codice prodotto'"
                                    :variant="(current_product_code == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_product_code"
                                >
                                    <b-dropdown-form>
                                        <b-form-input type="text" v-model="current_product_code" size="sm">
                                        </b-form-input>
                                        <b-button size="sm" variant="success"
                                            @click="() => {
                                                page = 1
                                                filter.product_code = current_product_code
                                                get_requests_paginated_from_api()
                                            }">
                                            invia
                                        </b-button>
                                    </b-dropdown-form>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_product_code !== ''"
                                    @click="() => {
                                        page = 1
                                        current_product_code = ''
                                        delete filter.product_code
                                        get_requests_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_name_surname !== '' ? current_name_surname : 'nome cliente'"
                                    :variant="(current_name_surname == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_name_surname"
                                >
                                    <b-dropdown-form>
                                        <b-form-input type="text" v-model="current_name_surname" size="sm">
                                        </b-form-input>
                                        <b-button size="sm" variant="success"
                                            @click="() => {
                                                page = 1
                                                filter.name_surname = current_name_surname
                                                get_requests_paginated_from_api()
                                            }">
                                            invia
                                        </b-button>
                                    </b-dropdown-form>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_name_surname !== ''"
                                    @click="() => {
                                        page = 1
                                        current_name_surname = ''
                                        delete filter.name_surname
                                        get_requests_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                            <div class="requests--filter">
                                <b-dropdown
                                    :text="current_email !== '' ? current_email : 'email cliente'"
                                    :variant="(current_email == '')? 'secondary' : 'success'"
                                    size="sm"
                                    ref="filter_email"
                                >
                                    <b-dropdown-form>
                                        <b-form-input type="text" v-model="current_email" size="sm">
                                        </b-form-input>
                                        <b-button size="sm" variant="success"
                                            @click="() => {
                                                page = 1
                                                filter.email = current_email
                                                get_requests_paginated_from_api()
                                            }">
                                            invia
                                        </b-button>
                                    </b-dropdown-form>
                                </b-dropdown>
                                <div class="requests--remove" v-if="current_email !== ''"
                                    @click="() => {
                                        page = 1
                                        current_email = ''
                                        delete filter.email
                                        get_requests_paginated_from_api()
                                    }"
                                ></div>
                            </div>
                        </div>
                        <div class="requests--filter">
                            <b-dropdown
                                :text="show_deleted_requests_criteria.filter(function(o) { return o.slug == show_deleted_requests })[0].friendly"
                                :variant="(show_deleted_requests == 0)? 'secondary' : 'danger'"
                                size="sm"
                                ref="trashed"
                            >
                                <b-dropdown-item v-for="(order,index) in show_deleted_requests_criteria" v-bind:key="'key_show_deleted_requests_' + index">
                                    <div v-html="order.friendly"
                                        @click="() => {
                                            page = 1
                                            show_deleted_requests = order.slug
                                            filter.trashed = order.slug
                                            get_requests_paginated_from_api()
                                        }"
                                    >
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div class="requests--filter">
                            <b-dropdown
                                :text="current_order_by !== '' ? order_criteria.filter(function(o) { return o.slug == current_order_by })[0].friendly  : 'ordina'"
                                :variant="(current_order_by == '')? 'secondary' : 'success'"
                                size="sm"
                                ref="sort"
                            >
                                <b-dropdown-item v-for="(order,index) in order_criteria" v-bind:key="'key_current_order_by_' + index">
                                    <div v-html="order.friendly"
                                        @click="() => {
                                            page = 1
                                            current_order_by = order.slug
                                            filter.sort = order.slug
                                            get_requests_paginated_from_api()
                                        }"
                                    >
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div class="requests--filter">
                            <select 
                                v-model="records_per_page"
                                @change="() => {
                                    page = 1
                                    get_requests_paginated_from_api()
                                }">
                                <option v-for="(option, index) in records_per_page_options" :value="option" v-bind:key="'key_records_per_page_' + index">
                                {{ option }}
                                </option>
                            </select>
                        </div>
                        <!--
                        <div class="requests--filter">
                            <b-button size="sm" variant="success" @click="get_requests_paginated_from_api">
                                carica
                            </b-button>
                        </div>-->
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <b-container fluid v-if="!loading">
            <div v-if="results.data.length" class="requests--wrapper">
                <table class="requests--table">
                    <tr>
                        <th></th>

                        <th :class="'requests--id th-sort ' + has_filter('request_id')" @click="sort_by('request_id')">R-ID</th>

                        <th :class="'requests--created th-sort ' + has_filter('created_at')" @click="sort_by('created_at')">creata</th>

                        <th :class="'requests--lastmod th-sort ' + has_filter('updated_at')" @click="sort_by('updated_at')">aggiornata</th>

                        <!--<th :class="'requests--travel th-sort ' + has_filter('travel_id')" @click="sort_by('travel_id')">travel id</th>-->

                        <th :class="'requests--customer th-sort ' + has_filter('name_surname')" @click="sort_by('name_surname')">cliente</th>

                        <!--<th :class="'requests--company th-sort ' + has_filter('customer_company')" @click="sort_by('customer_company')">company</th>-->
                        <th :class="'requests--company ' + has_filter('customer_company')">company</th>

                        <!--<th :class="'requests--budget th-sort ' + has_filter('customer_budget')" @click="sort_by('customer_budget')">budget</th>-->
                        <th :class="'requests--budget ' + has_filter('customer_budget')">budget</th>


                        <!--<th :class="'requests--availability th-sort ' + has_filter('customer_availability')" @click="sort_by('customer_availability')">disponibilità</th>-->
                        <th :class="'requests--availability ' + has_filter('customer_availability')">disponibilità</th>

                        <th :class="'requests--status th-sort ' + has_filter('request_status')" @click="sort_by('request_status')">status</th>

                        <!--<th :class="'requests--agent th-sort ' + has_filter('banconista_display_name')" @click="sort_by('banconista_display_name')">agent</th>-->
                        <th :class="'requests--agent ' + has_filter('banconista_display_name')" >agent</th>

                        <th :class="'requests--title th-sort ' + has_filter('quote_title')" @click="sort_by('quote_title')">proposta</th>

                        <th :class="'requests--productcode th-sort ' + has_filter('product_code')" @click="sort_by('product_code')">product code</th>

                        <th class="requests--buttons"></th>
                    </tr>
                    <tr v-for="request in results.data" v-bind:key="'key_request_id_' + request.request_id">
                        <td class="requests--id">
                          <b-badge v-if="request.attention_required == 1" :variant="'warning'">!</b-badge>
                        </td>
                        <td class="requests--id">
                            <b-button size="sm" variant="light" v-b-modal="'modal-request-'+request.request_id">
                                R-{{ request.request_id }} <font-awesome-icon icon="eye" />
                            </b-button>
                            <b-modal :id="'modal-request-'+request.request_id" title="Richiesta utente" size="lg">
                                <user-request :user_request="JSON.parse(request.user_request)" :pax="{}"/>
                            </b-modal>
                        </td>

                        <td class="requests--created">
                          {{ request.created_at | moment("DD-MM-YYYY HH:mm") }}
                        </td>

                        <td class="requests--lastmod">
                          <div v-if="request.updated_at != request.created_at">
                            {{request.updated_at | moment("DD-MM-YYYY HH:mm") }}
                          </div>
                        </td>

                        <!--<td class="requests--travel" v-html="request.travel_id"></td>-->

                        <td class="requests--customer" v-html="JSON.parse(request.user_request)['request-customer'].firstname + ' ' + JSON.parse(request.user_request)['request-customer'].lastname"></td>

                        <td class="requests--company" v-html="JSON.parse(request.user_request)['request-customer'].company"></td>

                        <td class="requests--budget">
                          <b-badge v-if="JSON.parse(request.user_request)['request-budget']" variant="info" title="budget indicato per il viaggio">{{ JSON.parse(request.user_request)['request-budget'].budget }} €</b-badge>
                        </td>

                        <td class="requests--availability">
                          <b-badge v-if="JSON.parse(request.user_request)['request-customer'].availability" variant="success" title="credito welfare attualmente disponibile">{{ JSON.parse(request.user_request)['request-customer'].availability }} €</b-badge>
                        </td>

                        <td class="requests--status">
                          <b-badge :variant="get_request_status(request)" v-html="request.request_status"></b-badge>

                          <b-button class="service-btn" size="sm" v-if="request.travelReviewLink" title="vedi revisione">
                            <a :href="request.travelReviewLink + '/noTrack'"  target="_blank" title="vedi revisione"><font-awesome-icon icon="eye" style="color:#fff"/></a>
                          </b-button>

                        </td>

                        <td class="requests--agent" v-html="request.banconista_display_name"></td>

                        <td class="requests--title" v-html="request.quote_title"></td>

                        <td class="requests--productcode" v-html="request.product_code"></td>

                        <td class="requests--buttons">
                            <history v-if="history_enabled" :request_id="request.request_id" />
                            <request-messages :request_id="request.request_id" />
                            <div v-if="my_banconiste_id != request.banconiste_id">
                                <b-button class="service-btn" size="sm" @click="self_assign_to_api(request.request_id)">
                                    <font-awesome-icon icon="download" />
                                </b-button>
                            </div>
                            <div v-else>
                                <div v-if="!show_deleted_requests">
                                <b-button class="service-btn" size="sm" @click="assign_to_user(request.request_id)">
                                    <font-awesome-icon icon="pen" />
                                </b-button>
                                
                                <b-button class="service-btn" size="sm" @click="self_duplicate_request(request.request_id)">
                                    <font-awesome-icon icon="clone" />
                                </b-button>
                                
                                <b-button class="service-btn" variant="danger" size="sm" @click="trash_request(request.request_id)">
                                    <font-awesome-icon icon="trash" />
                                </b-button>
                                </div>
                                <div v-else>
                                <b-button class="service-btn" variant="success" size="sm" @click="restore_a_request(request.request_id)" title="ripristina">
                                    <font-awesome-icon icon="retweet" />
                                </b-button>
                                </div>
                            <!--<b-button class="service-btn" size="sm" @click="self_unassign_request(request.request_id)">libera</b-button>-->
                            </div>
                        </td>
                    </tr>
                </table>
                <b-row>
                    <b-col cols="10" offset="1">
                        <pagination
                            :data="results"
                            @pagination-change-page="(page) => {
                                this.page = page
                                this.get_requests_paginated_from_api()
                            }"
                        >
                            <template #prev-nav>
                                <strong>&lt;</strong>
                            </template>
                            <template #next-nav>
                                <strong>&gt;</strong>
                            </template>
                        </pagination>
                    </b-col>
                </b-row>
            </div>

            <div v-else>
                <b-row>
                    <b-col cols="10" offset="1">
                        <p>nessuna richiesta</p>
                    </b-col>
                </b-row>
            </div>
        </b-container>

        <b-container fluid v-if="false /*!loading*/">
            <div v-if="results.data.length">
                <b-row class="request-row" v-for="request in results.data" v-bind:key="'key_request_id_' + request.request_id">
                    <b-col cols="4" offset="1">
                        <request-pad :request="request" />
                    </b-col>
                    <b-col cols="2">
                        <request-messages :request_id="request.request_id" />
                    </b-col>
                    <b-col cols="3" v-if="my_banconiste_id != request.banconiste_id">
                        <b-button class="service-btn" size="sm" @click="self_assign_to_api(request.request_id)">prendi in carico</b-button>
                    </b-col>
                    <b-col cols="3" v-else>
                      <b-button class="service-btn" size="sm" @click="assign_to_user(request.request_id)">lavora</b-button>
                      <b-button class="service-btn" size="sm" @click="self_duplicate_request(request.request_id)">duplica</b-button>
                      <!--<b-button class="service-btn" size="sm" @click="self_unassign_request(request.request_id)">libera</b-button>-->
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="10" offset="1">
                        <pagination
                            :data="results"
                            @pagination-change-page="(page) => {
                                this.page = page
                                this.get_requests_paginated_from_api()
                            }"
                        >
                            <template #prev-nav>
                                <strong>&lt;</strong>
                            </template>
                            <template #next-nav>
                                <strong>&gt;</strong>
                            </template>
                        </pagination>
                    </b-col>
                </b-row>
            </div>
            <div v-else>
                <b-row>
                    <b-col cols="10" offset="1">
                        <p>nessuna richiesta</p>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>    
</template>

<script>
    import Vue from 'vue'
    import LaravelVuePagination from 'laravel-vue-pagination';
    import { duplicate_request, get_requests_paginated, self_assign, unassign_request, delete_request, restore_request } from '@/api'
    import RequestPad from '@/components/blocks/request-pad'
    import RequestMessages from '@/components/blocks/request-messages'
    import UserRequest from '@/components/blocks/user-request'
    import History from '@/components/blocks/history'

    export default {
        name: 'requests',
        components: {
          'request-pad': RequestPad,
          'request-messages': RequestMessages,
          'pagination': LaravelVuePagination,
          'user-request': UserRequest,
          'history': History,
        },
        data() {
            return {
                loading: true,
                results: {},
                page: 1,
                records_per_page: 25,
                records_per_page_options: [10, 25, 50, 100],
                filter: {
                    'sort': 'updated_at.desc'
                },
                current_attention_required: '',
                attention_required_opts: [
                  {
                    value: 0,
                    label: 'in attesa',
                  },
                  {
                    value: 1,
                    label: 'da lavorare',
                  }
                ],
                current_rid: '',
                current_status: '',
                current_quote_title: '',
                current_product_code: '',
                current_banconista_id: '',
                current_name_surname: '',
                current_email: '',
                statuses: [
                    //'all',
                    'created',
                    //'open',
                    'assigned',
                    //'working',
                    'inReview',
                    'accepted',
                    'declined',
                    'rejected',
                    'published',
                    //'booked',
                ],
                current_order_by: 'updated_at.desc',
                order_criteria: [
                    {
                        friendly: 'Dal meno recente',
                        slug: 'created_at.asc',
                    },
                    {
                        friendly: 'Dal più recente',
                        slug: 'created_at.desc',
                    },
                    {
                        friendly: 'Modifiche recenti',
                        slug: 'updated_at.desc',
                    },

                ],
                show_deleted_requests: 0,
                show_deleted_requests_criteria: [
                    {
                        friendly: 'Richieste cestinate',
                        slug: 1,
                    },
                    {
                        friendly: 'Richieste attive',
                        slug: 0,
                    },
                ],
                banconiste: [
                    {
                        banconiste_id: Vue.prototype.$config.user.profile.id, display_name: 'MIE'
                    },
                    {
                        banconiste_id: 0, display_name: 'NON ASSEGNATE'
                    },
                    ...Vue.prototype.$config.banconiste
                ],
                my_banconiste_id: Vue.prototype.$config.user.profile.id,
                history_enabled: (Vue.prototype.$config.config.history_enabled)? true : false,
            }
        },
        computed: {
        },
        created()
        {
            this.get_requests_paginated = get_requests_paginated
        },
        mounted() {
            this.get_requests_paginated_from_api()
        },
        methods:{
            get_requests_paginated_from_api()
            {
                this.loading = true
                get_requests_paginated({
                    page: this.page,
                    records_per_page:this.records_per_page,
                    filter: this.filter,
                    sort: this.sort,
                })
                    .then((data) => {
                        this.results = data.result
                        this.loading = false
                    })
            },

            // unassigned/assigned to others
            self_assign_to_api(request_id)
            {
                self_assign({
                    request_id: request_id
                })
                    .then(
                        (success) => {
                            (success)
                            this.$router.push({
                                name: 'new-quote',
                                params: {
                                    request_id: request_id
                                }
                            })
                        }
                    )
            },

            // assigned
            assign_to_user(request_id)
            {
                this.$router.push({
                    name: 'new-quote',
                    params: {
                    request_id: request_id
                    }
                })
            },

            self_duplicate_request(request_id) //lmbo973 - duplicate request
            {

                if(!confirm('Vuoi duplicare la richiesta R-'+request_id+'?')) return
                Vue.$toast.info('duplico R-' + request_id)
                duplicate_request({ request_id: request_id})
                    .then(response => {
                        Vue.$toast.success('duplicata! nuova R-' + response.new_request_id)
                        this.$router.push({
                            name: 'new-quote',
                            params: {
                                request_id: response.new_request_id
                            }
                        })
                    })
            },

            trash_request(request_id) //lmbo973 - trash request
            {

                if(!confirm('Vuoi eliminare la richiesta R-'+request_id+'?')) return
                Vue.$toast.info('elimino R-' + request_id)
                delete_request({ request_id: request_id})
                    .then((success) => {
                        (success)
                        Vue.$toast.success('richiesta cestinata')
                        this.$router.go()
                    })
            },

            restore_a_request(request_id) //lmbo973 - trash request
            {

                if(!confirm('Vuoi ripristinare la richiesta R-'+request_id+'?')) return
                Vue.$toast.info('ripristino R-' + request_id)
                restore_request({ request_id: request_id})
                    .then((success) => {
                        (success)
                        Vue.$toast.success('richiesta ripristinata')
                        this.$router.go()
                    })
            },

            self_unassign_request(request_id)
            {
                if(!confirm('Vuoi "liberare" la richiesta? Potrà essere presa in carico da altro operatore')) return
                unassign_request({ request_id: request_id})
                    .then((success) => {
                        (success)
                        Vue.$toast.success('liberata')
                        this.$router.push({
                            name: 'requests',
                        })
                    })
            },

            get_request_status(request)
            {
                let status_variant = 'info'

                if(request.request_status == 'assigned') status_variant = 'warning'
                if(request.request_status == 'declined') status_variant = 'danger'
                if(request.request_status == 'accepted') status_variant = 'danger'
                if(request.request_status == 'inReview') status_variant = 'success'
                if(request.request_status == 'published') status_variant = 'success'
                if(request.request_status == 'booked') status_variant = 'success'     

                return status_variant
            },

            sort_by(slug)
            {
                if (this.filter.sort == slug+'.asc')
                {
                    this.filter.sort = slug+'.desc'
                }
                else if (this.filter.sort == slug+'.desc')
                {
                    this.filter.sort = slug+'.asc'
                }
                else 
                {
                    this.filter.sort = slug+'.asc'
                }
                this.get_requests_paginated_from_api()
            },

            has_filter(slug)
            {
                if (this.filter.sort == slug+'.asc') return 'active asc'
                if (this.filter.sort == slug+'.desc') return 'active desc'
                return ''
            }
        },
    }
</script>

<style lang="scss">
.requests
{
    width:100%;
    margin-left: 0;
    .request-row
    {
        &:nth-child(odd)
        {
            background-color:rgba(200,200,200,0.2);
        }
        padding:0.75rem 0;
        display:flex;
        align-items: center;
    }
    .pagination
    {
        margin:60px auto;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;        
    }

    &--topbar
    {
        display:flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom:20px;
    }
    &--filters
    {
        display:flex;
        align-items: center;
        flex:1;
    }
    &--filter
    {
        margin-right:1rem;
        display:flex;
        align-items: center;
        .dropdown-menu
        {
            overflow:hidden;
        }
        .b-dropdown-form
        {
            display:flex;
            input
            {
                min-width: 160px;
                border:0;
            }
            button
            {

            }
        }
    }
    &--remove
    {
        width:24px;
        height:24px;
        cursor:pointer;
        color:$info;
        position:relative;
        &:after
        {
            content:"x";
            position:absolute;
            top:50%;
            left:50%;
            transform:translateY(-50%) translateX(-50%);
        }
    }
    &--wrapper
    {
        max-width:100%;
        overflow-x:scroll;
    }
    &--table
    {
        width:100%;
        font-size:12px;
        .badge
        {
            font-size: 100%;
        }
        td,th
        {
            white-space: nowrap;
            padding:10px 16px;
        }
        th
        {
            text-align:left;
            padding:10px 16px;
        }
        .th-sort
        {
            cursor:pointer;
            transition:$transition-base;
            &:after
            {
                content: "";
                display:inline-block;
                margin-left:8px;
                width:10px;
                text-align: center;
            }
            &.active,
            &:hover
            {
                color:$cta;
            }
            &.active
            {
                &:after
                {
                    content:">";
                }
                &.asc:after
                {
                    transform:rotate(-90deg);
                }
                &.desc:after
                {
                    transform:rotate(90deg);
                }
            }
        }
        tr:nth-child(odd):not(:nth-child(1))
        {
            background:rgba($gray-200,0.5);
        }
        tr:nth-child(1)
        {
            background:rgba($gray-200,1);
        }
    }
    &--id
    {
        .btn
        {
            display:flex;
            width:100%;
            align-items: center;
            justify-content: space-between;
            svg
            {
                margin-left:8px;
            }
        }
    }
    &--travel
    {
        text-align: center;
    }
    &--productcode
    {

    }
    &--title
    {
        max-width: 20ch;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    &--status
    {
    }
    &--agent
    {
    }
    &--created
    {

    }
    &--customer
    {

    }
    &--company
    {

    }
    &--budget
    {

    }
    &--availability
    {

    }
    &--lastmod
    {
    }
    &--buttons
    {
        display:flex;
        align-items: center;
        &>*
        {
            margin-right:12px;
        }
    }

}
</style>